/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import styled from 'styled-components';

export const Container = styled.div`
  padding: 20px 37px 0 37px;
  text-align: center;
`;

export const Content = styled.div`
  margin-bottom: 10px;
`;

export const Title = styled.div`
  margin-top: 10px;
`;
